var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXBadgeSize12 = function SvgXBadgeSize12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1C2024",
    fillRule: "evenodd",
    d: "M3.146 3.146a.5.5 0 0 1 .708 0L6 5.293l2.146-2.147a.5.5 0 1 1 .708.708L6.707 6l2.147 2.146a.5.5 0 1 1-.708.708L6 6.707 3.854 8.854a.5.5 0 1 1-.708-.708L5.293 6 3.146 3.854a.5.5 0 0 1 0-.708",
    clipRule: "evenodd"
  })));
};
export default SvgXBadgeSize12;